// 加工指示のセクション定義です。
// label / panelId は s_logp から解決できるため fallback 値として持ち、
// 画面では GetListTabs.panels の値で上書きして利用します。
// 各要素の意味:
// - id: 画面内で使う固定のセクション識別子
// - view: どの表示モード(type1/type2/type3)で出すか
// - label: s_logp 未解決時の見出し fallback
// - component: 描画方式(base/grid/nb)
// - panelId: 既存処理互換の fallback パネルID
// - panelType: s_logp / s_layout の type
// - totalType: 合計パネルの fallback type
// - showActionArea / totalLayout: 画面固有のふるまい
export const kakousijiSectionCatalog = [
    // ベース系セクション
    { id: "product", view: "type1", label: "商品情報", component: "base", panelId: "0", panelType: "101", showActionArea: false },
    { id: "base1", view: "type1", label: "基本情報１", component: "base", panelId: "0", panelType: "102" },
    { id: "base2", view: "type1", label: "基本情報２", component: "base", panelId: "0", panelType: "103" },
    { id: "sozai", view: "type1", label: "素材", component: "base", panelId: "0", panelType: "106" },
    { id: "fuzoku", view: "type1", label: "附属", component: "base", panelId: "0", panelType: "109" },
    { id: "fukushizai", view: "type1", label: "副資材", component: "base", panelId: "0", panelType: "113", showActionArea: true },
    // 品質表示の操作エリアには複写元アイテム/グループ+複写ボタンを出す(複写対象は119-124、副資材複写とは独立)。
    { id: "hinshitsu", view: "type1", label: "品質表示", component: "base", panelId: "0", panelType: "118", showActionArea: true },
    { id: "sustainable", view: "type1", label: "サステナブルマーク", component: "base", panelId: "0", panelType: "128" },
    { id: "yobi", view: "type1", label: "トレーサビリティ情報", component: "base", panelId: "0", panelType: "129" },

    // グリッド系セクション
    { id: "sijisu", view: "type1", label: "指示数", component: "grid", panelId: "1", panelType: "104", totalType: "105", showActionArea: true },
    { id: "sozai_meisai", view: "type1", label: "素材明細", component: "grid", panelId: "2", panelType: "107", showActionArea: true },
    { id: "sozai_haisyoku", view: "type1", label: "素材配色", component: "grid", panelId: "3", panelType: "108" },
    { id: "fuzoku_meisai", view: "type1", label: "附属明細", component: "grid", panelId: "4", panelType: "110", showActionArea: true },
    { id: "fuzoku_haisyoku", view: "type1", label: "附属配色", component: "grid", panelId: "5", panelType: "111", showActionArea: false },
    { id: "fukushizai_ichiran", view: "type1", label: "使用副資材一覧", component: "grid", panelId: "6", panelType: "112", showActionArea: true },
    { id: "komonofuda", view: "type1", label: "小物札", component: "grid", panelId: "8", panelType: "114" },
    { id: "brandname", view: "type1", label: "ブランドネーム", component: "grid", panelId: "9", panelType: "115" },
    { id: "othername", view: "type1", label: "その他ネーム", component: "grid", panelId: "10", panelType: "116" },
    { id: "other_fukushizai", view: "type1", label: "その他副資材", component: "grid", panelId: "11", panelType: "117" },
    { id: "sosei", view: "type1", label: "組成", component: "grid", panelId: "13", panelType: "119" },
    { id: "hoteigai", view: "type1", label: "法定外表示", component: "grid", panelId: "14", panelType: "120" },
    { id: "fukiyogo", view: "type1", label: "付記用語", component: "grid", panelId: "15", panelType: "121" },
    { id: "koseibuhin", view: "type1", label: "構成部品", component: "grid", panelId: "16", panelType: "122" },
    { id: "demerit", view: "type1", label: "デメリット", component: "grid", panelId: "17", panelType: "123" },
    { id: "sentakuhyoji", view: "type1", label: "洗濯表示", component: "grid", panelId: "wash", panelType: "124" },
    { id: "genka", view: "type1", label: "原価", component: "grid", panelId: "19", panelType: "126", totalType: "127", totalLayout: "side" },
    { id: "jutyusu", view: "type2", label: "受注数", component: "grid", panelId: "20", panelType: "130" },
    { id: "nouhinyotei", view: "type3", label: "納品予定", component: "grid", panelId: "21", panelType: "131" }
];

// サンプル系セクション定義です。
export const kakousijiSampleSectionCatalog = [
    { id: "sample_base", view: "type1", label: "基本情報", component: "base", panelId: "0", panelType: "132", showActionArea: false },
    { id: "sample_info", view: "type1", label: "サンプル情報", component: "grid", panelId: "0", panelType: "133", totalType: "136", showActionArea: false },
    { id: "sample_comment", view: "type1", label: "サンプル情報 - 共通コメント", component: "nb", panelId: "nb", panelType: "137", showActionArea: false },
    { id: "sample_sosei", view: "type1", label: "組成", component: "grid", panelId: "23", panelType: "138", showActionArea: false }
];
